var map = {
	"./cup_1.svg": "w66Z",
	"./cup_2.svg": "sbGH",
	"./cup_3.svg": "wRs+"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "isHV";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images ^\.\/cup_.*\.svg$
// module id = isHV
// module chunks = 0